/**
 * WSH Collection Toggle — hybrid browse/filter mode
 *
 * Two-state collection page:
 *   Browse Mode (default): featured-collection carousels + bundle promo visible,
 *     native product grid hidden. Filter bar is always visible.
 *   Filter Mode: any active Shopify filter → carousels + bundle promo hide,
 *     native product grid appears.
 *   View All Mode: "View all X products" link reveals the grid without a filter,
 *     carousels still hide. "Back to browse" returns to browse mode.
 *
 * IMPORTANT: Always reads filter state from window.location.search (the URL),
 * never from event.shouldShowClearAll() which can be stale when filters are
 * triggered programmatically (e.g. from quick-filter pills).
 */
(() => {
  const BODY = document.body;
  const FILTER_CLASS = 'wsh-filter-mode';
  const VIEW_ALL_CLASS = 'wsh-view-all';

  /** Check URL for any active filter.* params */
  const hasActiveFilters = () => {
    const params = new URLSearchParams(window.location.search);
    for (const key of params.keys()) {
      if (key.startsWith('filter.')) return true;
    }
    return false;
  };

  const applyState = () => {
    const active = hasActiveFilters();
    BODY.classList.toggle(FILTER_CLASS, active);
    if (active) BODY.classList.remove(VIEW_ALL_CLASS);
  };

  // Set correct initial state on load
  applyState();

  // Always read from URL — never trust the event's stale form data
  document.addEventListener('filter:update', applyState);

  // Browser back/forward
  window.addEventListener('popstate', applyState);

  // "View all X products" link
  document.addEventListener('click', (event) => {
    const viewAll = event.target.closest('[data-wsh-view-all]');
    if (viewAll) {
      event.preventDefault();
      BODY.classList.add(VIEW_ALL_CLASS);
      const grid = document.querySelector('.product-grid-container');
      if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    const backToBrowse = event.target.closest('[data-wsh-back-to-browse]');
    if (backToBrowse) {
      event.preventDefault();
      BODY.classList.remove(VIEW_ALL_CLASS);
    }
  });
})();
